import axios from "axios";

const [baseUrl, controller] = `${(<any>window).baseUrl}`.split("rest")
export default axios.create({
    baseURL: `${baseUrl}ExternalApi`
});